// Standard Create React App v4 service worker registration helper (the same file the
// `cra-template-pwa` template generates) - only registers the service worker in production
// builds, and only on the same origin the app itself is served from. Left functionally as-is
// versus the stock template so it stays easy to recognize/compare against CRA's own docs; the
// one addition is threading `config.onUpdate`/`config.onSuccess` callbacks through, wired up in
// index.js to show a "new version available" notification rather than silently doing nothing.
const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // The service worker won't work if PUBLIC_URL is on a different origin (e.g. a CDN).
      return;
    }

    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log("This web app is being served cache-first by a service worker.");
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    // updateViaCache: "none" - "When I refresh page I don't see latest changes after its been
    // republished" from the original request. Without this, the browser was allowed to serve
    // service-worker.js itself from its own HTTP cache when checking for updates (on top of
    // whatever firebase.json's own headers now also guarantee server-side) - so a stale SW could
    // keep intercepting every navigation/refresh and serving its OWN precached (old) index.html
    // for as long as that cache entry lived, no matter how many times the page was reloaded.
    .register(swUrl, { updateViaCache: "none" })
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // A new version has already been downloaded and is waiting - it won't take over
              // until every tab of the old version is closed, unless the app itself asks it to
              // (see the "SKIP_WAITING" message posted from index.js's refresh button).
              console.log("New content is available and will be used when all tabs for this page are closed.");
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log("Content is cached for offline use.");
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (response.status === 404 || (contentType != null && contentType.indexOf("javascript") === -1)) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log("No internet connection found. App is running in offline mode.");
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
